import { videoEmbed } from "@/lib/video";

export const VideoEmbed = ({ url, title, className = "" }) => {
  const src = videoEmbed(url);
  if (!src) return null;
  return (
    <div className={`relative w-full overflow-hidden rounded-2xl bg-black shadow-sm ${className}`} style={{ aspectRatio: "16 / 9" }} data-testid="video-embed">
      <iframe
        src={src}
        title={title || "Vidéo"}
        className="absolute inset-0 h-full w-full"
        style={{ border: 0 }}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        loading="lazy"
      />
    </div>
  );
};

export default VideoEmbed;
